import { Signal } from '@angular/core';
import { Group } from '@app/shared/types/models/group/group.model';
import { IdBased } from '@app/shared/types/models/shared/id-based.model';

export class CooperationGroup implements IdBased {
  public id: string;
  public cooperationId: string;
  public group: Signal<Group | undefined>;

  public constructor(data: Partial<CooperationGroup>) {
    Object.assign(this, data);
  }
}
